<template>
  <div class="box box--project">
    <div class="box-inner">
      <router-link :to="`/hiring-requests/${box.idHireRequest}`" class="box-title">{{box.role}}</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxHireRequest",
  props: ['box'],
}
</script>
